export interface LogRenegociacaoCartao {
  actionLogger: AcaoRenegociacaoCartaoLoggerEnum;
  tokenParceiro?: string;
  rastreabilidade: string;
  token: string;
  cartao?: string;
  origem: string;
  dadosPropostas?: DadosProposta[];
  dadoPropostaEscolhida?: DadosProposta;
  dadoAcordo?: DadoAcordo;
  dividaId?: number;
  acordoId?: number | string;
  email?: string;
  nrParcela?: number;
  vencimento?: string;
  valorParcela?: number;
  linhaDigitavel?: string;
}

interface DadoAcordo {
  condicao: string;
  valorTotalPlano: number;
  dataEntrada: string;
  valorEntrada: number;
  quantidadeParcelas: number;
  valorParcelas: number;
  codigoBarras: string;
  email: string;
  celular: string;
  firstDefaultDate: string;
  linhaDigitavel: string;
}

interface DadosProposta {
  condicao: string;
  valorTotalPlano: number;
  dataEntrada: string;
  valorEntrada: number;
  quantidadeParcelas: number;
  valorParcelas: number;
}

export enum CondicaoPropostaEnum { 
  PARCELADO = 'PARCELADO',
  AVISTA = 'AVISTA'
}

export enum AcaoRenegociacaoCartaoLoggerEnum {
  ACESSAR_CARTAO_BRADESCO_ACTION = 'ACESSAR_CARTAO_BRADESCO_ACTION',
  ACESSAR_CARNE_ACTION = 'ACESSAR_CARNE_ACTION',
  CARTAO_BRADESCO_CONSULTAR_PROPOSTA_ACTION = 'CARTAO_BRADESCO_CONSULTAR_PROPOSTA_ACTION',
  CARTAO_BRADESCO_ESCOLHER_PROPOSTA_ACTION = 'CARTAO_BRADESCO_ESCOLHER_PROPOSTA_ACTION',
  CARTAO_BRADESCO_ACEITE_PROPOSTA_ACTION = 'CARTAO_BRADESCO_ACEITE_PROPOSTA_ACTION',
  CARTAO_BRADESCO_CONFIRMAR_ACORDO_ACTION = 'CARTAO_BRADESCO_CONFIRMAR_ACORDO_ACTION',
  CARTAO_BRADESCO_ENVIAR_EMAIL_BOLETO_ACTION = 'CARTAO_BRADESCO_ENVIAR_EMAIL_BOLETO_ACTION',
  CARTAO_BRADESCO_COPIAR_LINHA_DIGITAVEL_ACTION = 'CARTAO_BRADESCO_COPIAR_LINHA_DIGITAVEL_ACTION',
  CARTAO_BRADESCO_DOWNLOAD_BOLETO_ACTION = 'CARTAO_BRADESCO_DOWNLOAD_BOLETO_ACTION',
  CARTAO_BRADESCO_CONSULTAR_ACORDO_ACTION = 'CARTAO_BRADESCO_CONSULTAR_ACORDO_ACTION',
  CARTAO_BRADESCO_EMITIR_BOLETO_ACORDO_ACTION = 'CARTAO_BRADESCO_EMITIR_BOLETO_ACORDO_ACTION',
}
